<ng-container *ngIf="resultadoReporte">
    <!-- <app-lista-clientes>
    </app-lista-clientes> -->
</ng-container>